import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { WorkFlowMessageModel } from 'src/app/models/commissionsummary/workflowmessage.model';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { AddUser } from 'src/app/models/manageUsers/add-user.model';
import { appConfig } from 'src/app/service/auth-gaurd.service';
import { LoggerService } from 'src/app/service/logger.service';
import { environment } from 'src/environments/environment';
import { WorkflowApproval } from './workflow-approval.model';
import { WorkflowCriteria } from './workflow-criteria.model';
import { WorkflowDefination } from './workflow-defination.model';
import { WorkflowNames } from './workflow-names.model';
import { WorkflowTicket } from './workflow-ticket.model';
import { CommPlan } from 'src/app/models/commission/comm-plan.model';

@Injectable({
  providedIn: 'root'
})
export class ApprovalFlowService {
  host: string = environment.apiUrl + 'approval/workflow';
  hostcommission: string = environment.apiUrl + 'commission';
  pendingWorkflowTicket = new WorkflowTicket();

  constructor(private http: HttpClient,
    private logger: LoggerService) { }

  public getApprovalsData(employeeId: string, loggedinrole: string, stat: string, fdt: string, tdt: string): Observable<WorkflowTicket[]> {
    return this.http.get<WorkflowTicket[]>(`${this.host}/getapprovalsdata/` + employeeId + "/" + loggedinrole + "/" + stat + "/" + fdt + "/" + tdt);
  }

  public loadWorkflowNames() {
    const url = this.host + '/getworkflownames';
    return this.http.get<WorkflowNames[]>(url)
      .pipe(
        map((data: WorkflowNames[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public loadDropDownValues() {
    const url = this.host + '/getworkflowdefvalues';
    return this.http.get<WorkflowDefination[]>(url)
      .pipe(
        map((data: WorkflowDefination[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public createWorkFlowDef(workFlowDef: WorkflowDefination) {
    const url = this.host + '/createworkflowdef';
    this.logger.info('workFlowDef ===> ', workFlowDef);
    let body = workFlowDef ? JSON.stringify(workFlowDef) : '';
    this.logger.info('Request Body ==> ', body);
    return this.http.post(url, body, appConfig.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  public updateWorkFlowDef(updateWorkFlowDef: WorkflowDefination) {
    const url = this.host + '/updatestagelevelcriteria';
    this.logger.info('workFlowDef ===> ', updateWorkFlowDef);
    let body = updateWorkFlowDef ? JSON.stringify(updateWorkFlowDef) : '';
    this.logger.info('Request Body ==> ', body);
    return this.http.put(url, body, appConfig.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  public addApprovalWorkFlows(workFlowApprovals: WorkflowApproval[]) {
    const url = this.host + '/addapprovalworkFlow';
    this.logger.info('workFlowDef ===> ', workFlowApprovals);
    let body = workFlowApprovals ? JSON.stringify(workFlowApprovals) : '';
    this.logger.info('Request Body ==> ', body);
    return this.http.post(url, body, appConfig.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  public updateApprovalWorkFlows(workFlowApprovals: WorkflowApproval[]) {
    const url = this.host + '/updateapprovals';
    this.logger.info('workFlowDef ===> ', workFlowApprovals);
    let body = workFlowApprovals ? JSON.stringify(workFlowApprovals) : '';
    this.logger.info('Request Body ==> ', body);
    return this.http.put(url, body, appConfig.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  public getAllApprovalWorkFlows() {
    const url = this.host + '/getapprovalworkFlows';
    return this.http.get<WorkflowApproval[]>(url)
      .pipe(
        map((data: WorkflowApproval[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public fetchWorkflowByAprvlId(id: string) {
    const url = this.host + '/fetchworkflowbyaprvlid/' + id;
    return this.http.get<WorkflowApproval[]>(url)
      .pipe(
        map((data: WorkflowApproval[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public removeChargeback(removeid: number, removeStatus: string): Observable<CustomHttpRespone> {
    let url = this.host + '/removechargeback/' + removeid + '/' + removeStatus;
    return this.http.delete<CustomHttpRespone>(url);
  }

  public deleteWorkflowStages(id: number): Observable<CustomHttpRespone> {
    let url = this.host + '/deleteworkflowstage/' + id;
    return this.http.delete<CustomHttpRespone>(url);
  }

  public deleteWorkflowLevel(flowId: number, level: number): Observable<CustomHttpRespone> {
    let url = this.host + '/deleteworkflowlevel/' + flowId + '/' + level;
    return this.http.delete<CustomHttpRespone>(url);
  }

  public deleteApprovalById(id: number): Observable<CustomHttpRespone> {
    let url = this.host + '/deleteapproval/' + id;
    return this.http.delete<CustomHttpRespone>(url);
  }

  public deleteApprovalsByApprovalId(approvalId: string): Observable<CustomHttpRespone> {
    let url = this.host + '/deleteapprovals/' + approvalId;
    return this.http.delete<CustomHttpRespone>(url);
  }

  public handleError(error: { error: { message: string; }; status: any; message: any; }) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

  public fetchWorkflowDef(id: number) {
    const url = this.host + '/fetchworkflowdef/' + id;
    return this.http.get<WorkflowDefination[]>(url)
      .pipe(
        map((data: WorkflowDefination[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public loadStages(id: number, level: number) {
    const url = this.host + '/loadstages/' + id + '/' + level;
    return this.http.get<WorkflowDefination[]>(url)
      .pipe(
        map((data: WorkflowDefination[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public loadDefinitions(id: number, level: number, stage: number) {
    const url = this.host + '/loaddefinition/' + id + '/' + level + '/' + stage;
    return this.http.get<WorkflowDefination[]>(url)
      .pipe(
        map((data: WorkflowDefination[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public runSql(sql: string) {
    const url = this.host + '/runsql/' + sql;
    return this.http.get<any>(url)
      .pipe(
        map((data: any) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public addCriteriaToWorkflow(workflowCriteria: WorkflowCriteria) {
    const url = this.host + '/addworkflowcriteria';
    this.logger.info('workFlowDef ===> ', workflowCriteria);
    let body = workflowCriteria ? JSON.stringify(workflowCriteria) : '';
    this.logger.info('Request Body ==> ', body);
    return this.http.post(url, body, appConfig.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  public addFlow(workflowNames: WorkflowNames) {
    const url = this.host + '/addflow';
    this.logger.info('addFlow ===> ', workflowNames);
    let body = workflowNames ? JSON.stringify(workflowNames) : '';
    this.logger.info('Request Body ==> ', body);
    return this.http.post(url, body, appConfig.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  public loadCriteria(id: number, level: number) {
    const url = this.host + '/findcriteria/' + id + '/' + level;
    return this.http.get<WorkflowCriteria>(url)
      .pipe(
        map((data: WorkflowCriteria) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public loadStageCriteria(id: number, level: number, stage: number) {
    const url = this.host + '/findstagecriteria/' + id + '/' + level + '/' + stage;
    return this.http.get<WorkflowCriteria>(url)
      .pipe(
        map((data: WorkflowCriteria) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public loadCustGroupEmpIds(value: string) {
    const url = this.host + '/getcustgroupempid/' + value;
    return this.http.get<WorkflowApproval[]>(url)
      .pipe(
        map((data: WorkflowApproval[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public findEmpIdsByRole(role: string) {
    const url = this.host + '/getempidbyrole/' + role;
    return this.http.get<AddUser[]>(url)
      .pipe(
        map((data: AddUser[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public createWorkFlowTicket(workFlowTicket: WorkflowTicket[]) {
    const url = this.host + '/createworkflowticket';
    this.logger.info('workFlowDef ===> ', workFlowTicket);
    let body = workFlowTicket ? JSON.stringify(workFlowTicket) : '';
    this.logger.info('Request Body ==> ', body);
    return this.http.post(url, body, appConfig.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  public createTicket(workFlowTicket: WorkflowTicket) {
    const url = this.host + '/createticket';
    this.logger.info('workFlowDef ===> ', workFlowTicket);
    let body = workFlowTicket ? JSON.stringify(workFlowTicket) : '';
    this.logger.info('Request Body ==> ', body);
    return this.http.post(url, body, appConfig.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  public getTicketTrackingId() {
    const url = this.host + '/gettrackingid';
    return this.http.get<WorkflowTicket[]>(url)
      .pipe(
        map((data: WorkflowTicket[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public getTicetLevels(trackingId: string) {
    const url = this.host + '/getticketlevels/' + trackingId;
    return this.http.get<WorkflowTicket[]>(url)
      .pipe(
        map((data: WorkflowTicket[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public getTicetStages(trackingId: string, level: number) {
    const url = this.host + '/getticketstages/' + trackingId + '/' + level;
    return this.http.get<WorkflowTicket[]>(url)
      .pipe(
        map((data: WorkflowTicket[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public getTicketSubLevels(trackingId: string, level: number, subLevel: number) {
    const url = this.host + '/gettickesubtlevels/' + trackingId + '/' + level + '/' + subLevel;
    return this.http.get<WorkflowTicket[]>(url)
      .pipe(
        map((data: WorkflowTicket[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public findPendingApprovals(employeeId: string) {
    const url = this.host + '/pendingapprovals/' + employeeId;
    return this.http.get<WorkflowTicket[]>(url)
      .pipe(
        map((data: WorkflowTicket[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }



  public getCommissionPlans(selectedSalesChannel: string): Observable<CommPlan[]> {
    return this.http.get<CommPlan[]>(`${this.host}/getcommissionplans/` + selectedSalesChannel);
  }

  public getSalesChannels(): Observable<CommPlan[]> {
    return this.http.get<CommPlan[]>(`${this.hostcommission}/getsaleschannels`);
  }

  public approveRejectWorkflow(workflowTicket: WorkflowTicket[]): Observable<WorkflowTicket> {
    return this.http.put<WorkflowTicket>(`${this.host}/approverejectworkflow`, workflowTicket);
  }

  public findAllPendingApprovals(employeeId: string, impersonrole: string) {
    const url = this.host + '/allpendingapprovals/' + employeeId + '/' + impersonrole;
    return this.http.get<WorkflowTicket[]>(url)
      .pipe(
        map((data: WorkflowTicket[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public findAllPendingApprovalsDashboard(employeeId: string, impersonrole: string) {
    const url = this.host + '/allpendingapprovalsdash/' + employeeId + '/' + impersonrole;
    return this.http.get<WorkflowTicket[]>(url)
      .pipe(
        map((data: WorkflowTicket[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public findPendingTickets(trackingId: string) {
    const url = this.host + '/pendingtickets/' + trackingId;
    return this.http.get<WorkflowTicket[]>(url)
      .pipe(
        map((data: WorkflowTicket[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public getContentMessage(trackingId: string) {
    const url = this.host + '/getcontentmessage/' + trackingId;
    return this.http.get<WorkFlowMessageModel>(url)
      .pipe(
        map((data: WorkFlowMessageModel) => {
          console.log(data);
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public updateWorkflowTicket(updateTicket: WorkflowTicket) {
    const url = this.host + '/updateticket';
    this.logger.info('updateTicket ===> ', updateTicket);
    let body = updateTicket ? JSON.stringify(updateTicket) : '';
    this.logger.info('Request Body ==> ', body);
    return this.http.put(url, body, appConfig.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  public updateWorkflowTickets(updateTickets: WorkflowTicket[]) {
    const url = this.host + '/updatetickets';
    this.logger.info('updateTicket ===> ', updateTickets);
    let body = updateTickets ? JSON.stringify(updateTickets) : '';
    this.logger.info('Request Body ==> ', body);
    return this.http.put(url, body, appConfig.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  public getTicetLevelsAndStages(trackingId: string) {
    const url = this.host + '/getticketlevelsstages/' + trackingId;
    return this.http.get<WorkflowTicket[]>(url)
      .pipe(
        map((data: WorkflowTicket[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

    public getCommissionReportPreview(trackingId: string): Observable<any> {
    const url = `${this.host}/commission-report-preview/${trackingId}`;
    return this.http.get<any>(url)
      .pipe(
        map((data: any) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Error fetching commission report preview');
        })
      );
  }

}
